import { Conduit } from '@campingvision/conduit';
import { authentication } from '../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}core`,
  [],
  [authentication],
  [],
  false,
  3 * 60 * 1000,
  true,
);

export default {
  /**
   * @param brandIds Array<Int>
   * @return AxiosPromise
   */
  getDomainsByBrandIds(brandIds) {
    return conduit.post('/domains/by-brand-ids', { brandIds }, []);
  },

  /**
   * @return AxiosPromise
   */
  getDomains() {
    return conduit.get('/domains');
  },
};



// WEBPACK FOOTER //
// ./src/services/core-service.js